module.exports = __webpack_public_path__ + "static/img/level_chu.316d929.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/level_chu.png
// module id = Ni/k
// module chunks = 1